import { Reveal } from "@/components/Reveal";

const STEPS = [
  {
    tag: "01 / Idea",
    title: "Thought to Concept",
    body: "Shape an early thought into a clear premise, concept and creative direction.",
  },
  {
    tag: "02 / Story",
    title: "Concept to Story",
    body: "Develop the premise into a story, treatment and structured narrative.",
  },
  {
    tag: "03 / Format",
    title: "Screenplay & Dialogue",
    body: "Build the story into a screenplay, scenes and dialogue for the intended format.",
  },
  {
    tag: "04 / Support",
    title: "Connect Through SWA",
    body: "We can facilitate suitable connections between writers, producers and concept owners, with agreed commercial terms documented transparently.",
  },
];

export default function GoshtaWritingRoom() {
  return (
    <section
      id="writing-room"
      data-testid="goshta-writing-room"
      className="relative scroll-mt-24 border-y border-white/10 bg-[#0a0a0a] py-24 md:py-36"
    >
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <Reveal>
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#D4AF37]">Writing Room</p>
          <h2 className="mt-5 max-w-3xl font-display text-3xl font-medium leading-tight text-neutral-100 sm:text-4xl lg:text-5xl">
            Don&rsquo;t stop at the thought. <em className="italic text-[#D4AF37]">Let&rsquo;s build the story.</em>
          </h2>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-neutral-400">
            Every small thought may hold the seed of a film or series. We help concept owners and
            producers connect with suitable writers, including writers associated with the
            Screenwriters Association (SWA), to develop ideas into structured, pitch-ready material.
          </p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-px border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s, i) => (
            <Reveal
              key={s.tag}
              delay={i * 0.08}
              className="group bg-[#050505] p-8 transition-colors duration-500 hover:bg-[#0f0d09]"
            >
              <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#D4AF37]">{s.tag}</p>
              <h3 className="mt-5 font-display text-xl text-neutral-100 sm:text-2xl">{s.title}</h3>
              <p className="mt-4 text-sm leading-relaxed text-neutral-400">{s.body}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
